/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function initializeRecentlyViewedContainers() {
  var scrollContainers = document.querySelectorAll(".recently-viewed-wrapper");
  scrollContainers.forEach(function (container) {
    var scrollInner = container.querySelector(".js-scroll-inner");
    var scrollForward = container.querySelector('.js-scroll-forward');
    var scrollBackward = container.querySelector('.js-scroll-backward');
    var scrollCards = container.querySelectorAll('.featured-product');
    if (scrollCards.length === 0) return;
    var scrollCardsCount = scrollCards.length;
    var scrollCardWidth = scrollCards[0].offsetWidth;
    var totalGap = 0;

    for (var i = 1; i < scrollCardsCount; i++) {
      totalGap += scrollCards[i].offsetLeft - scrollCards[i - 1].offsetLeft - scrollCardWidth;
    }

    var gap = totalGap / (scrollCardsCount - 1);
    scrollBackward.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent the default form submission behavior

      scrollInner.scrollLeft -= scrollCardWidth + gap;
    });
    scrollForward.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent the default form submission behavior

      scrollInner.scrollLeft += scrollCardWidth + gap;
    });
    scrollInner.addEventListener('scroll', function () {
      // Check if we are at the far right of the scrollable area
      if (Math.ceil(scrollInner.scrollLeft) >= scrollInner.scrollWidth - scrollInner.clientWidth) {
        scrollForward.classList.add('opacity-30');
      } else {
        scrollForward.classList.remove('opacity-30');
      } // Check if we are at the far left of the scrollable area


      if (scrollInner.scrollLeft === 0) {
        scrollBackward.classList.add('opacity-30');
      } else {
        scrollBackward.classList.remove('opacity-30');
      }
    });
  });
}
/*
BG: Uses localStorage to store the products the user visits, and displays it back to the customer in a recently viewed section.
*/


var recentlyViewedProducts = function recentlyViewedProducts() {
  var recentlyViewedWrapper = document.querySelector('.js-recently-viewed-wrapper');
  var recentlyViewed = document.querySelector('.js-recently-viewed-products');
  var maxProducts = 10;
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")); //by default, we assume the prodict array is empty. 

  var productArray = []; //if localstorage exists, retrieve the list and output it

  if (savedRecentProducts) {
    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (savedRecentProducts.length > maxProducts) {
      savedRecentProducts.shift();
    } //update the product array to be the array stored in localStorage.


    productArray = savedRecentProducts;

    if (productArray.length >= 1) {
      recentlyViewedWrapper.classList.remove('hidden');
    }

    if (window.innerWidth > 1024) {
      if (productArray.length > 3) {
        recentlyViewedWrapper.classList.remove('hidden');
        recentlyViewedWrapper.querySelector('.js-scroll-backward').classList.remove('hidden');
        recentlyViewedWrapper.querySelector('.js-scroll-forward').classList.remove('hidden');
      }
    } else {
      if (productArray.length > 2) {
        recentlyViewedWrapper.classList.remove('hidden');
        recentlyViewedWrapper.querySelector('.js-scroll-backward').classList.remove('hidden');
        recentlyViewedWrapper.querySelector('.js-scroll-forward').classList.remove('hidden');
      }
    }

    productArray.forEach(function (productHandle, index) {
      //using that productHandle, get the product markup.
      fetch(window.Shopify.routes.root + "products/".concat(productHandle, "?view=recently-viewed")).then(function (response) {
        return response.text();
      }).then(function (html) {
        var preview = html.slice(0, 30);

        if (preview.includes("featured-product")) {
          recentlyViewed.innerHTML += html;

          if (index === productArray.length - 1) {
            initializeRecentlyViewedContainers();
          }
        } else {
          //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
          var removeProd = productArray.indexOf(productHandle);

          if (removeProd > -1) {
            productArray.splice(removeProd, 1);
          } //BG: Update localStorage, so we don't try and show it again.


          localStorage.setItem("recentProducts", JSON.stringify(productArray));
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    });
  } // if the recently viewed section has the product handle, add this product to the array.


  if (recentlyViewed.hasAttribute('data-product-handle')) {
    var productHandle = recentlyViewed.getAttribute('data-product-handle');

    if (!!productHandle) {
      //BG: only add the product to the array, if it doesn't already exist
      if (productArray.indexOf(productHandle) == -1) {
        productArray.push(productHandle);
      } //BG: Update localStorage


      localStorage.setItem("recentProducts", JSON.stringify(productArray));
    }
  }
}; //check if the section exists, if so, run the function.


if (!!document.querySelector('.js-recently-viewed-wrapper')) {
  recentlyViewedProducts();
}

function collectionToggles() {
  var toggleButton = document.querySelector('.collection-toggle-container');

  if (toggleButton != null) {
    setTimeout(function () {
      toggleButton.dataset.position = toggleButton.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 60;

      if (window.scrollY > toggleButton.dataset.position) {
        toggleButton.classList.add('collection-toggle-container--sticky');
      } else {
        toggleButton.classList.remove('collection-toggle-container--sticky');
      }
    }, 500);
    window.addEventListener('scroll', function () {
      if (window.scrollY > toggleButton.dataset.position) {
        toggleButton.classList.add('collection-toggle-container--sticky');
      } else {
        toggleButton.classList.remove('collection-toggle-container--sticky');
      }
    });
  }

  var collectionSidebar = document.querySelector('.collections-sidebar');

  if (collectionSidebar !== null) {
    var sections = document.querySelectorAll('.collection-section'),
        collectionListClose = document.querySelector('.collection-list-close');

    if (sections.length) {
      sections.forEach(function (section) {
        var sectionLink = document.createElement('a');
        sectionLink.href = "#".concat(section.id);
        sectionLink.innerHTML = section.dataset.title;
        sectionLink.classList.add('uppercase', 'text-xs', 'btn-link', 'w-fit');
        sectionLink.addEventListener('click', function (e) {
          e.preventDefault();
          collectionListClose.click();
          var sectionPosition = section.getBoundingClientRect().top + window.scrollY;
          var offsetPosition = sectionPosition - 60;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        });
        collectionSidebar.querySelector('.collections-sidebar__nav').appendChild(sectionLink);
      });
    }
  }
}

collectionToggles();
document.addEventListener("DOMContentLoaded", function () {
  var productContainer = document.getElementById("product-overlap-container");
  var paginationPreviousContainer = document.getElementById("pagination-container-previous");
  var paginationNextContainer = document.getElementById("pagination-container-next");
  var loadMorePrevBtn = paginationPreviousContainer === null || paginationPreviousContainer === void 0 ? void 0 : paginationPreviousContainer.querySelector("#collection-load-previous");
  var loadMoreNextBtn = paginationNextContainer === null || paginationNextContainer === void 0 ? void 0 : paginationNextContainer.querySelector("#collection-load-more"); // Function to load the next or previous page content

  function loadProducts(url, action) {
    var button = action === 'next' ? loadMoreNextBtn : loadMorePrevBtn;
    button.textContent = window.collection.loading;
    button.disabled = true;
    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      // Parse the response to extract new products and pagination links
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html"); // Extract products from the fetched page

      var newProducts = doc.querySelectorAll("#product-container"); // Append or prepend products based on action

      newProducts.forEach(function (product) {
        if (action === 'next') {
          productContainer.appendChild(product);
        } else if (action === 'previous') {
          productContainer.prepend(product);
        }
      }); // Update pagination links for next and previous pages

      updatePaginationLinks(doc, action); // Update the browser URL

      history.pushState(null, '', url);
    })["catch"](function (error) {
      console.error("Error loading products:", error);
    })["finally"](function () {
      // Reset button state
      button.textContent = action === 'next' ? window.collection.viewMore : window.collection.viewPrevious;
      button.disabled = false;
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    });
  } // Function to update pagination links based on the fetched content


  function updatePaginationLinks(doc, action) {
    var newPrevLink = doc.querySelector("#pagination-container-previous a");
    var newNextLink = doc.querySelector("#pagination-container-next a"); // Update previous link

    if (newPrevLink && loadMorePrevBtn) {
      loadMorePrevBtn.href = newPrevLink.href;
    } else if (!newPrevLink && action === 'previous') {
      paginationPreviousContainer.remove();
    } // Update next link


    if (newNextLink && loadMoreNextBtn) {
      loadMoreNextBtn.href = newNextLink.href;
    } else if (!newNextLink && action === 'next') {
      paginationNextContainer.remove();
    }
  } // Click Event Listener for "Load Previous" button


  if (loadMorePrevBtn) {
    loadMorePrevBtn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default anchor behavior

      var prevPageUrl = loadMorePrevBtn.href;
      loadProducts(prevPageUrl, 'previous');
    });
  } // Click Event Listener for "View More" button


  if (loadMoreNextBtn) {
    loadMoreNextBtn.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default anchor behavior

      var nextPageUrl = loadMoreNextBtn.href;
      loadProducts(nextPageUrl, 'next');
    });
  }
}); // Assuming your products have a unique data attribute like 'data-product-id'

document.querySelectorAll('.product-collection-item a').forEach(function (item) {
  item.addEventListener('click', function () {
    var productID = item.getAttribute('data-product-id');
    sessionStorage.setItem('lastViewedProductID', productID);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var lastViewedProductID = sessionStorage.getItem('lastViewedProductID');

  if (lastViewedProductID) {
    var productElement = document.querySelector("[data-product-id=\"".concat(lastViewedProductID, "\"]"));

    if (productElement) {
      productElement.scrollIntoView();
      sessionStorage.removeItem('lastViewedProductID'); // Clean up storage after scrolling
    }
  }
});
/******/ })()
;